/**
 * links.js — URLs canónicas reutilizables
 * Usar siempre estas constantes en lugar de hardcodear URLs en componentes.
 */

export const LINKEDIN_PROFILE_URL = "https://www.linkedin.com/in/dprudencio";
